import DesignAndEng from "../Assets/services/design.png";
import EPC from "../Assets/services/construction.png";
import ProjectManag from "../Assets/services/project management.png";
import Electrical from "../Assets/services/electrical.png";
import QualityAssur from "../Assets/services/qa.png";
import FactLayout from "../Assets/services/factory layout.png";
import ElecDesign from "../Assets/services/Elec des.png";

export const Services_data = [
    {
        Title: "Design & Engineering Services",
        Image: DesignAndEng,
        Subheading: "Comprehensive Solutions for Design and Engineering",
        Content: "We offer comprehensive design and engineering services tailored to meet the specific needs of our clients. Our team of experienced engineers and designers work collaboratively to develop innovative solutions that ensure project success. From initial concept development to detailed design, we provide expertise in all aspects of design and engineering to deliver high-quality results."
    },
    {
        Title: "EPC Services",
        Image: EPC,
        Subheading: "Engineering, Procurement, and Construction Services",
        Content: "Our EPC (Engineering, Procurement, and Construction) services cover the entire project lifecycle, from initial planning to final execution. We ensure seamless integration of all project phases, providing a single point of responsibility for the complete project. Our expertise in EPC services ensures timely delivery, cost efficiency, and high-quality outcomes."
    },
    {
        Title: "Project Management Consultancy",
        Image: ProjectManag,
        Subheading: "Expert Project Management Services",
        Content: "Our Project Management Consultancy (PMC) services offer expert guidance and support throughout the project lifecycle. We assist our clients in planning, executing, and monitoring projects to ensure they are completed on time, within budget, and to the highest quality standards. Our experienced project managers employ best practices and advanced methodologies to drive project success."
    },
    {
        Title: "Electrical HT & LT Work",
        Image: Electrical,
        Subheading: "Comprehensive Electrical Services",
        Content: "From scratch to handover, we manage high and low tension (HT & LT) electrical works with precision and expertise. Our services include detailed electrical design, installation, testing, and commissioning. We ensure compliance with all relevant standards and regulations, providing reliable and efficient electrical solutions for various industrial and commercial projects."
    },
    {
        Title: "Third Party Inspection",
        Image: QualityAssur,
        Subheading: "Independent Quality Assurance",
        Content: "Our third-party inspection services provide independent verification and quality assurance for your projects. We conduct thorough inspections to ensure compliance with industry standards and project specifications. Our objective assessments help identify potential issues early, ensuring that your project meets the highest quality standards."
    },
    {
        Title: "Factory Layouts & Equipment Installation",
        Image: FactLayout,
        Subheading: "Optimized Factory Layouts and Equipment Installation",
        Content: "We specialize in designing optimized factory layouts and installing machinery and equipment for various industrial applications. Our services include MEP (Mechanical, Electrical, Plumbing) installations, commissioning, and annual maintenance contracts. We ensure efficient factory operations by providing well-planned layouts and reliable equipment installation.",
    },
    {
        Title: "Electrical Design & Execution",
        Image: ElecDesign,
        Subheading: "Detailed Electrical Design and Execution",
        Content: "Our electrical design and execution services cover all aspects of electrical work, from detailed design to implementation. We provide solutions that are tailored to meet the specific needs of our clients, ensuring safety, efficiency, and reliability. Our team follows approved drawings and standards to deliver high-quality electrical installations."
    },
]